<template>
  <div id="summary-dashboard">
    <b-card
      no-body
      class="py-2 container-card mb-1 bg-summary d-flex flex-wrap w-100"
      :class="hasMoreFour? 'more-four':'justify-content-end'"
    >
      <b-row class="">
        <b-col cols="12" class="text-center">
          <div>
            <img :src="summaryObj.image_url" alt="" class="image-summary" />
          </div>
          <div class="font-medium-5 font-weight text-header">
            {{ summaryObj.name }}
          </div>
          <div class="font-large-1 font-color-blue ">
            {{ summaryObj.score }}
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    summaryObj: { type: Object, default: {} },
    hasMoreFour: { type: Boolean, default: false },
  },
  setup() {
    return {};
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/document-detail/document-detail.css";
</style>
